export enum DriverIdType {
  VisitorBadge = 'VISITOR_BADGE',
  IdCard = 'ID_CARD',
  DriverLicence = 'DRIVER_LICENCE',
  Passport = 'PASSPORT',
}
